// Returns the URL only if it is an absolute http(s) URL, e.g. for links taken
// from external feeds. Mirrors Widgets::Rss.safe_item_url on the server.
export default function safeHttpUrl(url?: string | null): string | undefined {
  const value = url?.trim();
  // eslint-disable-next-line no-control-regex
  if (!value || /[\u0000-\u001f\u007f\\\s]/.test(value)) return undefined;

  return /^https?:\/\/[^/?#]+/i.test(value) ? value : undefined;
}
